import {DataListModel} from '../interface';
import {HomeCarouselModel} from './home-carousel.model';

export class HomeCarouselItemsModel extends DataListModel {
  items: HomeCarouselModel[] = [];
}
